import { render, staticRenderFns } from "./AlarmRuleDetail.vue?vue&type=template&id=4480525c&scoped=true&"
import script from "./AlarmRuleDetail.vue?vue&type=script&lang=js&"
export * from "./AlarmRuleDetail.vue?vue&type=script&lang=js&"
import style0 from "./AlarmRuleDetail.vue?vue&type=style&index=0&id=4480525c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4480525c",
  null
  
)

export default component.exports